/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
import React, { memo, useEffect, useMemo } from 'react';
import PdfIcon from 'images/pdf_icon.png';
import Mp3Icon from 'images/mp3_file.png';
import IconMC from '../../../components/IconMC';
import ImageMC from '../../../components/ImageMC';
import VideoMC from '../../../components/VideoMC';
import useSelectedConversation from '../../../hooks/shared/useSelectedConversation';

const MessageReplyPreviewMC = memo(({ message, onClose }) => {
  const conversation = useSelectedConversation();
  const messageText = useMemo(() => {
    if (!message) return '';
    return message.messageText || message.contentMediaCaption || message.locationURL || message.contentType?.toUpperCase() || '';
  }, [message]);

  const isFile = message?.contentMediaType === 'file';
  const isVideo = message?.contentMediaType === 'video';
  const isAudio = message?.contentMediaType === 'audio';
  const wh = isAudio || isFile ? 'tw-w-10' : '!tw-h-10 !tw-w-10';

  const url = useMemo(() => {
    if (isFile) return PdfIcon;
    if (isAudio) return Mp3Icon;
    return message?.contentMediaUrl;
  }, [message?.contentMediaUrl, isFile, isAudio]);

  useEffect(() => {
    if (!conversation?.id) return;

    onClose?.();
  }, [conversation?.id, onClose]);

  if (!message) return null;

  return (
    <div key={`product-${message.id}`} className="tw-relative tw-flex tw-items-start tw-p-2 tw-rounded-lg tw-bg-gray-50 tw-border-l-4 tw-border-blue-300 tw-mb-1 tw-w-11/12 tw-ml-auto">
      <div className="tw-absolute tw-top-[-8px] tw-right-[-8px] tw-z-10 tw-bg-transparent">
        <IconMC
          name="close-circle-fill"
          size="xl"
          className="tw-text-gray-400 hover:tw-text-red-500 tw-bg-white tw-rounded-full"
          onClick={onClose}
        />
      </div>
      <div className="tw-flex tw-w-full">
        <div className="tw-w-4/5 tw-pr-2">
          <div className="tw-font-bold tw-text-base">
            {conversation.fullName}
          </div>
          <div dangerouslySetInnerHTML={{ __html: messageText }} />
        </div>
        <div className="tw-w-1/5 tw-flex tw-items-center tw-justify-end">
          {isVideo ? (
            <VideoMC
              key={url}
              data={{ contentMediaUrl: url }}
              className="!tw-h-20 !tw-w-20 tw-rounded-lg"
            />
          ) : (
            <ImageMC
              key={url}
              data={{ contentMediaUrl: url }}
              alt="Fast Answer"
              className={`${wh} tw-object-cover tw-rounded-lg tw-border tw-border-gray-200`}
            />
          )}
        </div>
      </div>
    </div>
  );
});

MessageReplyPreviewMC.displayName = 'MessageReplyPreviewMC';

export default MessageReplyPreviewMC;
